import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-down",
  "use": "icon-arrow-down-usage",
  "viewBox": "0 0 21 21",
  "content": "<symbol viewBox=\"0 0 21 21\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-arrow-down\">\n    <path d=\"m1.55 6.281 8.5 8.501 8.502-8.5h-1.768l-6.733 6.731L3.32 6.281z\" fill=\"#D91D22\" fill-rule=\"evenodd\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol